const LAST_VIEWED_PAGE_KEY = "mmm-last-viewed-page";

export const DEFAULT_APP_PAGE = "/dashboard";

function normalizedPath(pathname: string): string {
  if (pathname.length > 1 && pathname.endsWith("/")) return pathname.slice(0, -1);
  return pathname;
}

export function isRestorableAppPage(pathname: string): boolean {
  const path = normalizedPath(pathname);
  const segments = path.split("/").filter(Boolean);

  if (segments.length === 1) {
    return ["dashboard", "tasks", "calendar", "deleted", "subjects"].includes(segments[0]);
  }

  if (segments[0] !== "subjects" || !segments[1]) return false;
  if (segments.length === 2) return true;

  if (segments.length === 3) {
    return ["overview", "tasks", "calendar", "map", "tests"].includes(segments[2]);
  }

  if (segments[2] === "chapters" && segments[3]) {
    return segments.length === 4 || (segments.length === 5 && ["overview", "map", "tests"].includes(segments[4]));
  }

  if (segments[2] === "tests" && segments[3]) {
    if (segments.length === 4) return true;
    if (segments[4] !== "attempts" || !segments[5]) return false;
    return segments.length === 6 ||
      (segments.length === 7 && ["mark", "review"].includes(segments[6]));
  }

  return false;
}

export function getLastViewedPage(): string {
  try {
    const stored = localStorage.getItem(LAST_VIEWED_PAGE_KEY);
    return stored && isRestorableAppPage(stored) ? normalizedPath(stored) : DEFAULT_APP_PAGE;
  } catch {
    return DEFAULT_APP_PAGE;
  }
}

export function recordLastViewedPage(pathname: string): void {
  const path = normalizedPath(pathname);
  if (!isRestorableAppPage(path)) return;
  try {
    localStorage.setItem(LAST_VIEWED_PAGE_KEY, path);
  } catch {
    // Navigation still works when storage is unavailable; only restoration is lost.
  }
}
